import moment from 'moment'

class ChartDateHighlighter {
    getPreviousDate = (dateArray) => {
        if (dateArray.length) {
          const previous = dateArray[dateArray.length - 1]
          return moment(previous).format('MMM DD');
        }
    }

    barHeight = (chart, index) => {
        if (chart.config.type === 'bar') {
          var height = 0
          chart.config.data.datasets.forEach(function (chart) {
            height += Object.values(chart._meta)[0].data[index].height()
          })
          return height;
        }
    }

    drawDateHighlihter = (chart, ctx, dateArray) => {
        let that = this
        var previousDate = that.getPreviousDate(dateArray)
        var index = chart.options.lineAtIndex;
        var date = moment(chart.options.selectedDate).format('MMM DD')
        return chart.config.data.datasets.forEach(function (dataset) {
            if (dateArray.length && dataset.label !== 'Primary' && dataset.label !== 'Benchmark0' && dataset.label !== 'Benchmark1' && dataset.label !== 'Benchmark2' && dataset.label !== 'Benchmark3' && dataset.label !== 'Benchmark4' && dataset.label !== 'Benchmark5') {
                var data =
                'data:image/svg+xml,' +
                `<svg xmlns="http://www.w3.org/2000/svg" ${previousDate === date || index === 0 ? 'width="85px"': 'width="70px"'} height="200">` +
                '<foreignObject width="100%" height="100%">' +
                `<div xmlns="http://www.w3.org/1999/xhtml" ${previousDate === date || index === 0 ?'style="display:flex;flex-direction:row;font-size:15px;text-align:center"' : 'style="font-size:15px;text-align:center"' }>` +
                `${index === 0 ? '<div style="width: 0;height: 0;border-top: 7px solid transparent;border-bottom: 7px solid transparent;border-right: 7px solid rgba(233,233,233,255);margin-top:10px"></div>' : '<div></div>'}<div style="border-radius:5px;background-color:white;border:1px solid rgba(233,233,233,255);padding:7px"><span style="color:rgb(64,137,251);font-family: Uni Sans Regular, Calibri, Arial, sans-serif">${date}</span></div>
                ${previousDate === date ? '<div style="width: 0;height: 0;border-top: 7px solid transparent;border-bottom: 7px solid transparent;border-left: 7px solid rgba(233,233,233,255);margin-top:10px"></div>' : index != 0 ?
                '<div style="width: 0;height: 0;margin-left:28px;border-left: 7px solid transparent;border-right: 7px solid transparent;border-top: 7px solid rgba(233,233,233,255)"></div>' : '<div></div>'}` +
                '</div>' +
                '</foreignObject>' +
                '</svg>';
                var img = new Image()
                img.src = data;
                img.onload = function () {
                    if (index || index === 0) {
                        ctx.drawImage(img, xaxis.getPixelForValue(undefined, index) - `${previousDate === date ? 66 : index != 0 ? 35 : 0}`, yaxis.top - 7);
                    }
                };
                if (index || index === 0) {
                var xaxis = chart.scales['x-axis-0'];
                var yaxis = chart.scales['y-axis-0'];
                var barHeight = that.barHeight(chart, index)
                ctx.save();
                ctx.beginPath();
                ctx.moveTo(xaxis.getPixelForValue(undefined, index), yaxis.top + 10);
                ctx.strokeStyle = '#4089FB';
                ctx.lineTo(xaxis.getPixelForValue(undefined, index), yaxis.bottom - `${chart.config.type === 'bar' ? barHeight : 0}`);
                ctx.stroke();
                ctx.restore();
                ctx.font = '14px Uni Sans Light'
                ctx.fillStyle = '#4089FB'
                ctx.textAlign = 'center';
                }
            }
        })
    }
}

const instance = new ChartDateHighlighter()

export default instance